import React, { useState } from 'react';
import Icon from '../../../generic-components/Icon';
import Button from '../../../generic-components/Button';

interface IProps {
  actionId: string;
  buttonTitle: string;
  onClick?: () => void;
  leftIcon: string;
  rightIcon?: string;
  rightIconHovered?: string;
  handleToggle?: () => void;
  toggleState?: boolean;
}

const CardActionButton = ({
  rightIcon, rightIconHovered, leftIcon, onClick, buttonTitle, handleToggle, toggleState, actionId,
}:IProps) => {
  const [icon, setIcon] = useState(rightIcon ?? null);
  return (
    <div>
      {!handleToggle
        ? (
          <Button
            className='flex h-[68px] w-full justify-between items-center font-metricMedium text-sm text-bw07 border-bw03 border-b-[0.5px]'
            id={actionId}
            onClick={() => {
              if (onClick) {
                onClick();
              }
            }}
            handleMouseEnter={() => {
              if (rightIconHovered) setIcon(rightIconHovered);
            }}
            handleMouseLeave={() => {
              if (rightIcon) setIcon(rightIcon);
            }}
            childElement={(
              <>
                <div className='flex items-center -ml-2'>
                  <Icon className='w-[36px] h-[36px] mr-2' src={leftIcon} />
                  <span>{buttonTitle}</span>
                </div>
                <Icon src={icon ?? ''} className='text-red02 stroke-red02' />
              </>
      )}
          />
        ) : (
          <div
            className='flex h-[68px] w-full justify-between items-center font-metricMedium text-sm text-bw07 border-bw03 border-b-[0.5px]'
            id={`wrapper_${actionId}`}
          >
            <div className='flex items-center -ml-2'>
              <Icon className='w-[36px] h-[36px] mr-2' src={leftIcon} />
              <span>{buttonTitle}</span>
            </div>
            <Button
              id={actionId}
              childElement={<div id='toggler' className={`w-[1.125rem] h-[1.125rem] rounded-full ${toggleState ? 'bg-action03 bg-opacity-100' : 'bg-bw06'}`} />}
              onClick={() => { handleToggle(); }}
              className={`w-[3rem] h-[1.5rem] px-1 rounded-2xl flex items-center ${toggleState ? 'flex-row-reverse bg-bw05 bg-opacity-50' : 'flex-row bg-bw03'}`}
            />
          </div>
        ) }
    </div>
  );
};

export default CardActionButton;
